/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

const AWSFSSRegions = [
  {
    name: 'US East (N. Virginia)',
    value: 'us-east-1',
  },
  {
    name: 'US East (Ohio)',
    value: 'us-east-2',
  },
  {
    name: 'US West (N. California)',
    value: 'us-west-1',
  },
  {
    name: 'US West (Oregon)',
    value: 'us-west-2',
  },
  { name: null, value: null },
  {
    name: 'Africa (Cape Town)',
    value: 'af-south-1',
  },
  { name: null, value: null },
  {
    name: 'Asia Pacific (Hong Kong)',
    value: 'ap-east-1',
  },
  {
    name: 'Asia Pacific (Hyderabad)',
    value: 'ap-south-2',
  },
  {
    name: 'Asia Pacific (Jakarta)',
    value: 'ap-southeast-3',
  },
  {
    name: 'Asia Pacific (Malaysia)',
    value: 'ap-southeast-5',
  },
  {
    name: 'Asia Pacific (Melbourne)',
    value: 'ap-southeast-4',
  },
  {
    name: 'Asia Pacific (Mumbai)',
    value: 'ap-south-1',
  },
  {
    name: 'Asia Pacific (Osaka)',
    value: 'ap-northeast-3',
  },
  {
    name: 'Asia Pacific (Seoul)',
    value: 'ap-northeast-2',
  },
  {
    name: 'Asia Pacific (Singapore)',
    value: 'ap-southeast-1',
  },
  {
    name: 'Asia Pacific (Sydney)',
    value: 'ap-southeast-2',
  },
  {
    name: 'Asia Pacific (Tokyo)',
    value: 'ap-northeast-1',
  },
  { name: null, value: null },
  {
    name: 'Canada (Central)',
    value: 'ca-central-1',
  },
  {
    name: 'Canada (Calgary)',
    value: 'ca-west-1',
  },
  { name: null, value: null },
  {
    name: 'Europe (Frankfurt)',
    value: 'eu-central-1',
  },
  {
    name: 'Europe (Ireland)',
    value: 'eu-west-1',
  },
  {
    name: 'Europe (London)',
    value: 'eu-west-2',
  },
  {
    name: 'Europe (Milan)',
    value: 'eu-south-1',
  },
  {
    name: 'Europe (Spain)',
    value: 'eu-south-2',
  },
  {
    name: 'Europe (Paris)',
    value: 'eu-west-3',
  },
  {
    name: 'Europe (Stockholm)',
    value: 'eu-north-1',
  },
  {
    name: 'Europe (Zurich)',
    value: 'eu-central-2',
  },
  { name: null, value: null },
  {
    name: 'Middle East (Bahrain)',
    value: 'me-south-1',
  },
  {
    name: 'Middle East (UAE)',
    value: 'me-central-1',
  },
  { name: null, value: null },
  {
    name: 'South America (São Paulo)',
    value: 'sa-east-1',
  },
]

export const AWS_DEPLOY_INPUT_KEYS = [
  'awsScannerStackManagementRole',
  'awsStorageStackManagementRole',
] as Redux.DeployStackInputKeyName[]

export default AWSFSSRegions
